import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class UserRoleModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (UserRoleModel._instance == null) UserRoleModel._instance = new UserRoleModel(authManager);
        return UserRoleModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'core/user-roles');

        this.entityName = 'core.UserRole';
        this.privileges = {
            create: [["adminUsers"]],
            read: [["adminUsers"],["manageUsers"],["editUsers"],["readUsers"]],
            update: [["adminUsers"]],
            delete: [["adminUsers"]],
        };

        this.label = 'User Role';
        this.setLabel = 'User Roles';

        this.browser = {
            name: 'default-core-userrole-browser',
            moduleName: 'default-core-userrole-browser',
            moduleTitle: 'User Roles',
            moduleStateSlotName: 'default-core-userrole-browser',
        };

        this.editor = {
            name: 'default-core-userrole-editor',
            moduleName: 'default-core-userrole-editor',
            moduleTitle: 'User Role',
            moduleStateSlotName: 'default-core-userrole-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'userId',
                type: 'User',
                persistent: true,
                label: 'User',
            },
            {
                name: 'userLabel',
                type: 'string',
                persistent: false,
                label: 'User',
                distinctLabel: 'User (Text)',
                readOnly: true,
            },
            {
                name: 'roleId',
                type: 'Role',
                persistent: true,
                label: 'Role',
            },
            {
                name: 'roleLabel',
                type: 'string',
                persistent: false,
                label: 'Role',
                distinctLabel: 'Role (Text)',
                readOnly: true,
            },
            {
                name: 'roleCode',
                type: 'string',
                persistent: false,
                label: 'Role Code',
                readOnly: true,
            },
        ];

    }

}
